module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-273.f08acef.woff2";